import DropdownClassList from "root/s360components/ReactHookForm/ui/DropdownClassList";
import {FormInputDatePicker} from "root/ReactHookForm/FormComponents";
import DropdownAMPM, {AM_OBJ, PM_OBJ} from "root/s360components/ReactHookForm/ui/DropdownAMPM";
import ToggleIncludeLunch from "root/s360components/ReactHookForm/ui/ToggleIncludeLunch";
import './HookSubFormRegistrationFilter.scss';
import {RegistrationFormSections} from "root/s360components/Registration/RegistrationPage";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";
import {Fragment, useEffect} from "react";


export const RegistrationFilterNames = {
    CLASSES: 'classes',
    DATE: 'date',
    SESSION: 'ampm',
    LUNCH: 'lunchtoggle'
}

export const regFilters = (initialSessionObject) =>
{
    return {
        [RegistrationFormSections.FILTERS]:
            {
                [RegistrationFilterNames.CLASSES]: { value: 0 , label: "No classes"},
                [RegistrationFilterNames.DATE]: Date.now(),
                [RegistrationFilterNames.SESSION]: initialSessionObject !== null ? initialSessionObject : { value: 0 , label: "No sessions"},
                [RegistrationFilterNames.LUNCH]: false
            }
    }
}

const HookSubFormRegistrationFilters = ({control, resetField, watch, getValues, setValue, formErrors, sectionName, readOnly, school_id, class_id_filter}) =>
{

    const sessionOptions = [
        AM_OBJ,
        PM_OBJ,
    ]

    return (
        <Fragment>
            <div className='registration-filter-item'>
                <DropdownClassList control={control} school_id={school_id} name={sectionName + '.' + RegistrationFilterNames.CLASSES} readOnly={false} placeholder={"Please select a class"} class_id_filter={class_id_filter} setValue={setValue}/>
            </div>
            <div className='registration-filter-item'>
                <FormInputDatePicker control={control} sectionName={sectionName} name={RegistrationFilterNames.DATE} formErrors={formErrors} readOnly={false} maxDate={new Date()}/>
            </div>
            <div className='registration-filter-item'>
                <DropdownAMPM control={control} name={sectionName + '.' + RegistrationFilterNames.SESSION} readOnly={false} placeholder={"Please select a time"} options={sessionOptions}/>
            </div>
            <ToggleIncludeLunch control={control} name={sectionName + '.' + RegistrationFilterNames.LUNCH} readOnly={false}/>
        </Fragment>
    )
}

export default HookSubFormRegistrationFilters;